export default function Alerta({ texto, tipo }) {
  return (
    <div className={'my-2 alert alert-' + tipo}>
      <b>{texto}</b>
    </div>
  );
}
